var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"d-block text-truncate",staticStyle:{"max-width":"500px"}},[_vm._v(" "+_vm._s(_vm.display)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }